import React from 'react';
import { Field } from 'redux-form';
import TPGrid from 'components/TP-UI/TPGrid';
import FormError from 'modules/common/FormError';
import TPDatePicker from 'components/TP-UI/TPDatePicker';
import { DATE_FORMAT_DDMMYYYY } from 'constants/index';
import { required } from 'utils/validation/fieldValidationRules';
import TPSelect from 'components/TP-UI/TPSelect';
import PropTypes from 'prop-types';

const ExportMarketingDataForm = ({ sources, error, submitFailed }) => {
  return (
    <TPGrid container spacing={3} direction="column">
      {error && submitFailed ? (
        <TPGrid item>
          <FormError error={error} />
        </TPGrid>
      ) : null}
      <TPGrid item container spacing={2} direction="column">
        <TPGrid item>
          <Field
            name="dateFrom"
            component={TPDatePicker}
            returnsStartDay
            label="Date From"
            placeholder={DATE_FORMAT_DDMMYYYY}
            fullWidth
            required
            validate={[required]}
          />
        </TPGrid>
        <TPGrid item>
          <Field
            name="dateTo"
            component={TPDatePicker}
            label="Date To"
            placeholder={DATE_FORMAT_DDMMYYYY}
            fullWidth
            required
            validate={[required]}
          />
        </TPGrid>
        <TPGrid item>
          <Field
            name="source"
            component={TPSelect}
            label="Source"
            options={sources}
            placeholder="Source"
            fullWidth
            required
            validate={[required]}
          />
        </TPGrid>
      </TPGrid>
    </TPGrid>
  );
};

ExportMarketingDataForm.propTypes = {
  sources: PropTypes.array.isRequired,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  submitFailed: PropTypes.bool,
};

export default ExportMarketingDataForm;
